export class ETransactionQuestion
 {​​
    url: string;
    hmackey: string;
    value:string;
    pbX_SITE: string;
    pbX_RANG: string;
    pbX_IDENTIFIANT: string;
    pbX_TOTAL: string;
    pbX_DEVISE: string;
    pbX_CMD: string;
    pbX_PORTEUR: string;
    pbX_REPONDRE_A: string;
    pbX_RETOUR: string;
    pbX_EFFECTUE: string;
    pbX_ANNULE: string;
    pbX_REFUSE: string;
    pbX_HASH: string;
    pbX_TIME: string;
    pbX_HMAC: string;
    pbX_SHOPPINGCART: string;
    pbX_BILLING : string;
}​